/**
 * Name: Search songs saga
 * Author: @Gaurav
 * Date: 19-07-2021
 */
import { put, takeLatest, call } from 'redux-saga/effects';
import ApiCaller from '../ApiCaller';

const callAPI = (payload) => {
  const search = payload?.search || '';
  const date = payload?.date || null;
  const queryParams = new URLSearchParams();
  if (search && search.trim() !== '') queryParams.append('search', search);
  if (date) queryParams.append('date', date);
  return ApiCaller(`/v1/admin/songs?${queryParams.toString()}`, 'GET');
};

export default function* watchRequest() {
  yield takeLatest('SEARCH_SONGS', function* performAction(action) {
    yield put({ type: 'SEARCH_SONGS_INITIATED' });
    try {
      const data = yield call(callAPI.bind(this, action.payload));
      yield put({ type: 'SEARCH_SONGS_SUCCESS', payload: data });
    } catch (error) {
      yield put({ type: 'SEARCH_SONGS_FAILED', payload: error });
    }
  });
}
